import { render, staticRenderFns } from "./AccountsOverview.vue?vue&type=template&id=db5872de"
import script from "./AccountsOverview.vue?vue&type=script&lang=js"
export * from "./AccountsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports